// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown[data-v-207a3c17]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
